import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static classes = ["open"]
  static values = {
    open: Boolean,
    revealHeader: Boolean
  }

  connect() {
    this.boundHandleOpened = this.handleOpened.bind(this)
    window.addEventListener("dropdown:opened", this.boundHandleOpened)

    if (this.openValue) this.openValueChanged()
  }

  disconnect() {
    window.removeEventListener("dropdown:opened", this.boundHandleOpened)
    document.removeEventListener("click", this.clickOutside)
  }

  toggle(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.openValue = !this.openValue
  }

  // Explicit close action (e.g. for the "X" button or "Keep shopping" button)
  close(event) {
    if (event) event.preventDefault()
    this.openValue = false
  }

  // Handle global exclusivity event
  handleOpened(event) {
    if (this.openValue && event.detail.element !== this.element) {
      this.openValue = false
    }
  }

  openValueChanged() {
    const target = this.hasContainerTarget ? this.containerTarget : this.element

    if (this.openValue) {
      target.classList.add(this.openClass)

      const openEvent = new CustomEvent("dropdown:opened", {
        detail: { element: this.element }
      })
      window.dispatchEvent(openEvent)

      if (this.revealHeaderValue) {
        document.documentElement.classList.add("scrolled-up")
        document.documentElement.classList.remove("scrolled")
      }

      // Bind the click-outside listener
      setTimeout(() => document.addEventListener("click", this.clickOutside), 10)
    } else {
      target.classList.remove(this.openClass)
      // Unbind the click-outside listener
      document.removeEventListener("click", this.clickOutside)
    }
  }

  // The listener for the document click
  clickOutside = (event) => {
    // If the click happened INSIDE this dropdown, do nothing.
    if (this.element.contains(event.target)) return

    this.openValue = false
  }
}
